import createReducer from 'Lib/createReducer';
import { OPEN_NOTE_EDITOR, RESET_ANNOTATION } from './index';


const initialState = {
  isNoteEditorOpen: false
};

const actionHandlers = {
  [OPEN_NOTE_EDITOR]: (state, action) => {
    return { isNoteEditorOpen: !state.isNoteEditorOpen } ;
  },

  [RESET_ANNOTATION]: (state, action) => {
    return initialState;
  }
};


export default createReducer(initialState, actionHandlers);
